// Generate a simple random key using timestamp + random characters
// This is used to generate a unique key for each element in the DOM
// to prevent React from reusing the same key for different elements
export const uniqueId = () => {
	const timestamp = Date.now().toString(36); // Convert timestamp to base36
	const randomPart = Math.random().toString(36).substring(2, 8); // Get 6 random chars
	return `${timestamp}-${randomPart}`;
};
